export default function (Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "",
    "resource": {
      "es": {
        "labels": {
          "go_back_link": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Volver a la lista de procesos"])},
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Contenedores"])},
          "show_link": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ver"])},
          "total_number_containers": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Contenedores"])},
          "total_number_inspections": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Inspecciones"])}
        }
      },
      "en": {
        "labels": {
          "go_back_link": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Go back link to list of process"])},
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Containers"])},
          "show_link": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Show"])},
          "total_number_containers": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Containers"])},
          "total_number_inspections": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Inspections"])}
        }
      }
    }
  })
}